'use strict';

var cov_1unwywv3mq = function () {
  var path = 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\directives\\translations_en.js',
      hash = '14a9ce71e94e635b91ed8426c4b4ebd91236cb69',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\directives\\translations_en.js',
    statementMap: {
      '0': {
        start: {
          line: 2,
          column: 0
        },
        end: {
          line: 741,
          column: 7
        }
      },
      '1': {
        start: {
          line: 5,
          column: 6
        },
        end: {
          line: 739,
          column: 15
        }
      },
      '2': {
        start: {
          line: 740,
          column: 6
        },
        end: {
          line: 740,
          column: 49
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 4,
            column: 12
          },
          end: {
            line: 4,
            column: 13
          }
        },
        loc: {
          start: {
            line: 4,
            column: 34
          },
          end: {
            line: 741,
            column: 5
          }
        },
        line: 4
      }
    },
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0
    },
    f: {
      '0': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_1unwywv3mq.s[0]++;

angular.module('app').config(function ($translateProvider) {
  cov_1unwywv3mq.f[0]++;
  cov_1unwywv3mq.s[1]++;

  $translateProvider.translations('en', {
    MESSAGE: {
      TITLE: 'Mail Box',
      READ_ALL: 'Read all Messages',
      INBOX: 'Inbox',
      SEND_BOX: 'Send Mail',
      DRAFT_BOX: 'Drafts',
      TRASH_BOX: 'Trash',
      REFRESH: 'Refresh',
      REPLY: 'Reply',
      IMPORTANT: 'Important',
      VIEW_MSG: 'View Message',
      TO: 'To',
      SUBJECT: 'Subject',
      FROM: 'From',
      DRAFT: 'Draft',
      DISCARD: 'Discard',
      CMP_MSG: 'Compose Mail',
      SEND: 'Send',
      EMAIL_BOX: 'Mailbox',
      FOLDER: 'Folder',
      REMOVE: 'Remove',
      ERROR: {
        TO: 'Please select recipient!',
        SUBJECT: 'Enter Subject'
      }
    },
    LOGIN: {
      TITLE: 'Sahara and Sahel Observatory',
      TITLE1: 'WEB database for Monitoring and Evaluation',
      TITLE2: 'of SAWAP Performance Indicators',
      FOOTTITLE: 'Building Resilience through Innovation, Communication and Knowledge Services (BRICKS)',
      PROFILE: 'Profile',
      LOGOUT: 'Logout',
      ERROR_CHECK: 'You have been disconnected!',
      ERROR_LOGIN1: 'Error in email or password!',
      ERROR_LOGIN2: 'The account is currently used!'
    },

    ALERT: {
      IND_TEXT: 'Indicator Alerts',
      DOCUMENT: 'new documents',
      MORE: 'See All Alerts',
      ALL: 'All Alerts',
      NBR_J_L: 'Days before'
    },
    TODO: {
      TITLE: 'Todo List',
      LABEL: 'Label'
    },
    HOME: {
      WELCOME: 'Collaborative Web based  Software for M&E',
      USER: 'User name',
      PASS: 'Password',
      LOGIN: 'Login'
    },
    COMMON: {
      SATELLITE: 'Satellite Image',
      CITIES: 'Cities',
      DENIED: 'Access Denied',
      RIGHT: {
        VEIWING: 'Browse',
        UPDATING: 'Edit',
        DELETING: 'Delete',
        PAGE: 'Functions'
      },
      STATUT: {
        NOSTART: 'Not started',
        PROGRESS: 'In progress',
        DONE: 'Completed'
      },
      SAVE: 'Save',
      VIRGULE: '.',
      NEXT: 'Next',
      PREV: 'Previous',
      ADD: 'New',
      EDIT: 'Edit',
      DELETE: 'Delete',
      DAY: 'Day',
      PRINT: 'Print',
      SELECT: 'Select',
      YEAR: 'Year',
      SEM: 'Semester',
      QUATR: 'Quadrimester',
      TRIM: 'Quarter',
      BIM: 'Bimester',
      MOIS: 'Month',
      PERIOD: 'Period',
      YEAR_SHORT: 'Y',
      SEM_SHORT: 'S',
      QUATR_SHORT: 'Qd',
      TRIM_SHORT: 'Q',
      BIM_SHORT: 'B',
      MOIS_SHORT: 'M',
      DISPLAY: 'Display',
      VALIDATE: 'Validate',
      CANCEL: 'Cancel',
      CONFIRM: 'are you sure?',
      YES: 'Yes',
      NO: 'No',
      ERROR_DELETE: 'Can\'t delete!',
      ERROR_UPDATE: 'Can\'t update!',
      ERROR_ADD: 'Can\'t add!',
      TITLE_ERROR_ADD: 'An error was detected during the update',
      TITLE_ERROR_DELETE: 'Data is used by another',
      DATE_FORMAT: 'MM/DD/YYYY',
      DATE_FORMAT_MM_YYYY: 'MMMM YYYY',
      HISTORQ: 'Recent',
      CLOSE: 'close',
      DATE_DP: 'Start Date',
      ACTUAL: 'Actual Date',
      DATE_DR: 'Start Date',
      DATE_FP: 'End Date',
      DATE_FR: 'End Date',
      H_DEB: 'Start time',
      H_FIN: 'End time',
      LIEU: 'Locality',
      MSG_ADD: 'Record added  !',
      MSG_MODIF: 'Update completed !',
      MSG_DEL: 'Deletion completed !',
      TBORD: 'Dashboard',
      YEAR_ALL: 'All (*)',
      ALL: 'All (*)',
      ALL_E: 'All (*)',
      NONE: 'None',
      NONE_E: 'None',
      SEARCH: 'Search',
      LINECHART: 'Line Chart',
      BARCHART: 'Bar Chart',
      PIECHART: 'Donut Chart',
      POLARCHART: 'Polar Chart',
      BEGIN: 'Begin',
      END: 'End',
      LESS_THAN: 'Less than',
      GREAT_THAN: 'Great than',
      EGAL_TO: 'Egale to',
      LESS_THAN_E: 'Less than',
      GREAT_THAN_E: 'Great than',
      EGAL_TO_E: 'Egale to',
      OPEN: 'Open',
      DOWNLOAD: 'Download',
      QUIT: 'Quit'
    },
    MENU: {
      ALERT: 'Alerts',
      D_B: 'Settings',
      DO: 'Projects',
      D_T: 'Time division',
      D_P: 'Periods',
      D_PL: 'Planning Division',
      UN: 'Units',
      AC: 'Stakeholders',
      S_F: 'Funding sources',
      P_G: 'Geographic map',
      S_G: 'Geographical division',
      T_I: 'Type of Indicators',
      IN: 'Indicators ',
      IN_T: 'Track Indicators ',
      R_F: 'Results Framework',
      P_L: 'Customize Label',
      P_LO: 'Logframe ',
      ST: 'Structure',
      P_B: 'Budget Plan',
      P_M: 'Procurement Plan',
      FL: 'Flag',
      PL: 'Planning',
      P_A: 'Plan Activities',
      P_AN_PTBA: 'Annual Plan (AWPB)',
      IMP_BUDG: 'Import Budget',
      G_F_PF: 'Generate pre-formatted file',
      I_B: 'Import budgets',
      P_I: 'Plan Indicators',
      S_E: 'Monitoring',
      S_A: 'Monitor Activity',
      I_C: 'Import Costs',
      I_COUT: 'Importing Costs',
      S_PTBA: 'AWPB Progress',
      S_PTBP: 'Multiannual WPB Monitoring',
      T_B_A: 'Activity Dashboard',
      C_GANTT: 'Gantt diagram',
      P_AC: 'Action plan',
      R_P: 'Custom Queries',
      MA: 'Contracts',
      S_M: 'Contracts Monitor',
      S_PPM: 'PP monitoring',
      S_I: 'Indicator Monitoring',
      S_I_IOV: 'Indicators',
      S_I_G: 'Geographic tracking of Indicators',
      T_B_I: 'Indicators Dashboard',
      SY: 'Summary',
      C_L: 'Logframe ',
      S_C_L: 'Logframe monitoring',
      S_C: 'Context',
      G_R: 'Risk management',
      P_M_R: 'Risk mitigation plan',
      F_P: 'Positive Factors',
      E_T: 'Lessons Learned',
      M_R: 'Missions / Meetings',
      T_M: 'Missions categories',
      MIS: 'Missions',
      C_M: 'Missions Chronogram',
      CA_MIS: 'Missions calendar',
      T_R: 'Meetings categories',
      RES: 'Meetings',
      CA_RE: 'meetings schedule',
      B_D: 'Document Database',
      T_RA: 'Reports categories',
      CA_R: 'Reporting Schedule',
      C_D: 'Documents files',
      PH: 'Photo library',
      AD: 'Administration',
      G_U: 'Users',
      GR_U: 'User Groups',
      U_C: 'Connected Users',
      J_C: 'Connections journal',
      R_I: 'User Profile'
    },
    PROJECT: {
      TITLE: 'Projects',
      NEWP: 'Add',
      FROM: 'from',
      TO: 'to',
      PROCESS: 'progress...',
      COMPLETE: 'Completion with',
      PROJECT: 'Project',
      INFO: 'Informations',
      CODE: 'Code',
      LABEL: 'Label',
      CURRENCY: 'Currency',
      D_DEB: 'Start Date',
      D_FIN: 'End Date',
      COOR: 'contact Information',
      ADR: 'Adress',
      PAYS: 'Country',
      TEL: 'Telephone',
      FAX: 'Fax',
      MAIL: 'E-mail',
      OTHER: 'Other',
      AGENC: 'Agency',
      DESCR: 'Description',
      CODE_ERR: 'code not avaible',
      CONFIRM_DELETE: 'Do you want to delete this Project?',
      SELECT: 'Select',
      CHANGE_PIC: 'Change Picture',

      GOAL: 'Goal',
      TARGET: 'Target',
      AREA: 'Area',
      DATE_MID: 'Date mid-term review',
      STATUS: 'Status',
      COST: 'Cost',
      FINAN: 'Financing'

    },
    BTN: {
      ADD: 'Add',
      MOD: 'Edit',
      DEL: 'Delete',
      CAN: 'Cancel',
      PRI: 'Print',
      VAL: 'Valide',
      NEX: 'Next Page',
      PRE: 'Previous Page'
    },
    FN_UNIT: {
      LST_TI: 'Units list',
      ED_TI: 'Unit details',
      COD: 'Code',
      LAB: 'Label',
      TYP: 'Type',
      FOR: 'Format',
      CB_N: 'Numeric',
      CB_P: '%',
      CB_B: 'Boolean',
      CB_T: 'Text',
      CB_D: 'Date',
      NEWU: 'Create new Unit',
      COLU: 'Unit',
      CONFIRM_DELETE: 'Do you want to delete this unit?'

    },
    FN_ACTORS: {
      LST_AC: 'Stakeholders',
      ED_AC: 'Stakeholder Sheet',
      COD: 'Code',
      NOM: 'Name',
      PRE: 'First name',
      FON: 'Fonction',
      IMG: 'Image',
      GRO: 'User Group',
      NEWA: 'Create new Actor',
      LAB_AC: 'Activities',
      LAB_LSTAC: 'Activities List',
      LAB_MI: 'Missions',
      LAB_LSTMI: 'Missions List',
      LAB_RE: 'Meeting',
      LAB_LSTRE: 'Meeting List',
      LAB_RA: 'Reports',
      LAB_LSTRA: 'Reports List',
      LAB_TYPRA: 'Report Type',
      FILT: 'Filter',
      ETAV: 'State of play',
      RESNIVO: 'Level of Responsibility',
      CHECK_A1: 'In progress',
      CHECK_A2: 'Completed',
      CHECK_A3: 'Late',
      CHECK_A4: 'In advance',
      CHECK_A5: 'Global',
      CHECK_A6: 'Local',
      CONFIRM_DELETE: 'Do you want to delete this Actor?'

    },
    FN_SFIN: {
      LST_FIN: 'Financing sources',
      ED_FIN: 'Financing source details',
      CONFIRM_DELETE: 'Do you want to delete this sources ?'
    },
    FN_TYPINDIC: {
      LST_TYP: 'List of Types of Indicators',
      ED_TYP: 'Details Type of indicator',
      COL_COLOR: 'Color',
      COLOR_BLUE: 'Blue',
      COLOR_CRYAN: 'Cyan',
      COLOR_GREEN: 'Green',
      COLOR_YELOW: 'Yellow',
      COLOR_ORANGE: 'Orange',
      COLOR_RED: 'Red',
      COLOR_PINK: 'Pink',
      COLOR_PURPLE: 'Purple',
      COLOR_GREY: 'Grey',
      COLOR_BLACK: 'Black',
      CONFIRM_DELETE: 'Do you want to remove this indicator type?'
    },
    DASHBOARD: {
      TITLE: 'Dashboard',
      V_R: 'Reference value',
      V_C: 'Target value',
      FROM: 'from',
      TO: 'to',
      PROCESS: 'Progress...',
      COMPLETE: 'Completed',
      SIT_INDIC: 'Indicators Status',
      REP_ACTIVITE: 'Activities Status',
      PHY: 'Activity Progress',
      FIN: 'Budget Consomption',
      GRAPHE_PERF: 'Performance Graphic',
      SUIV_PTBA: 'AWPB Progress (Change in execution rates)',
      DASHBOARD: 'Dashboard',
      RESUME_PROJECT: 'Project Snapshot',
      EVOLUTION_TABLE: 'Indicator Progress ',
      REALIZE: '% achived Project End',
      YEAR: 'Year',
      PERIOD: 'Period'
    },
    TIME_DIVISION: {
      PERIOD: 'Period',
      PTBA: 'Current AWPB',
      PLAN_AN: 'Annuel Plan',
      LEVEL: 'Level',
      BEGIN: 'Begin',
      END: 'End',
      LABEL: 'Label'
    },
    GEOGRAPHIC_PLAN: {
      ADD__: 'Add locality',
      ADD: 'Add sub locality',
      SUM: 'Sum',
      MOY: 'Average',
      MAXI: 'Maximum',
      MINI: 'Minimum',
      AGGREGA: 'Agregate',
      CHAMPPERSO: 'Custom field',
      LABEL: 'Label',
      CONFIRM_DELETE: 'Do you want to delete this field?',
      LONG: 'Longueur',
      ERROR_UPDATE_LONG: 'Can\'t update the length.',
      CONFIRM_DELETE_LEVEL: 'Do you want to delete this level?',
      CONFIRM_DELETE_LOCALTION: 'Voulez vous supprimer this locality?',
      CODE: 'Code',
      DESCRP: 'Description',
      IMPORT: 'Import Geographic Plan'
    },
    INDICATOR: {
      LESS_THAN: 'Value must be less than or equal to {{valeur}}',
      GREAT_THAN: 'Value must be greater than or equal to {{valeur}}',
      EGAL_TO: 'Value must be equal to {{valeur}}',
      BEETWEEB: 'Value must be between {{valeur_min}} and {{valeur_max}}',
      ERROR_UPDATE: 'An error occured while updating!',

      ERROR_DECOUP_PLAN: {
        TITLE: 'Error',
        VALUE: 'Please enter a value',
        DATE_RELEVE: 'Please enter the planned date',
        DATE_ALERT: 'Please enter the alert date',
        DATE_RELEVE_T: 'The planned date must be greater than the beginning of the period and the start date of the indicator'
      },

      SELECT: 'List',
      LOCATION: 'Area',
      CALMETHOD: 'Calculation method',
      CRITERIA: 'Criteria ',
      CODE: 'Code',
      KEY_KPI: 'Core Indicator',
      NAME: 'Name',
      NAME_FRENCH: 'Name (French)',
      NAME_ENG: 'Name (English)',
      DEF: 'Definition /  Description',
      UNIT: 'Unit',
      TYPE: 'Type',
      CLASS: 'Class',
      KEY: 'Indicators',
      VAL_POSS: 'Possibles values',
      FORMULA: {
        INVALID: 'Incorrect formula',
        NONEINDIC: 'No indicator in the formula'
      },
      BEGIN: 'Start date',
      END: 'End date',
      FREQUENCE: 'Periodicity',
      NIV_GEO: 'Geographic Level',
      AGGREGA: 'Aggregation',
      GROUP_CIBLE: 'Target group',
      HYPOTHESE: 'Assumptions',
      MOY_VERIF: 'Means of verification',
      TECH_COLL: 'Collection technique',
      TARGET: 'End Target Value',
      REF: 'Baseline Value',
      TARGET_VAL: 'Target Value',
      REAL_VAL: 'Actual Value',
      VARIANCE: 'Variance',
      TRANS: 'Transversal indicator',
      SIMPL: 'Simple',
      COMPO: 'Composite',
      CUMUL: 'Cumulative',
      COMPL: 'Complex',
      SUM: 'Sum',
      MOY: 'Average',
      MAXI: 'Maximum',
      MINI: 'Minimum',
      NONE: 'None',
      MOD_UN: 'La modification de l\'unité entraînera la perte de tous les relevés.\nVoulez-vous continuer?',
      MOD_NG: 'La modification du niveau géographique entraînera la perte de tous les relevés.\nVoulez-vous continuer?',
      MOD_DATE: 'La modification des dates pourrait entraîner la perte de plusieurs relevés.\nVoulez-vous continuer?',
      MOD_PER: 'La modification de la périodicité pourrait entraîner la perte de plusieurs relevés.\nVoulez-vous continuer?',
      MOD_CLS: 'La modification de la classe entraînera la perte de tous les relevés.\nVoulez-vous continuer?',
      LABEL_VP: 'Libellé',
      POUND: 'Pondération',
      PLAN: 'Planning',
      DATE_R: 'Planned Date ',
      VALUE: 'Value',
      BUDGET: 'Budget',
      COST: 'Cost',
      REL: 'Indicator Data Collection',
      RAPP: 'Indicator Report',
      PIC: 'Picture',
      IN_MON: 'Indicator Monitoring',
      MON: 'Monitor',
      DATA_FIN: 'Cost ',
      FOLLOW_FIN: 'Track Budget/Cost',
      DISPLAY_CODE_LOC: 'Display geographic codes',
      COMMENTS: 'Comments',
      RESPO: 'Responsible',
      DISPLAY_PL: 'Display ',
      ACHEVE: '% Achieved',
      SOCIO_ECO: 'Socio-economic',
      SPATIAL: 'Spatial',
      GRAPHE_COMBINE: 'Mixed Graph',
      CONFIRM_DELETE: 'Do you want to delete this indicator?',
      CONFIRM_DELETE_RELEVE: 'Do you want to delete this data?',
      CONFIRM_DELETE_PLAN: 'Do you want to delete this planning?',
      DATE_ALERT: 'Alert Date',
      GLOBAL: {
        TITLE: 'Baseline and final Target Values ',
        LOCATION: 'Area',
        BEGIN: 'Start date',
        END: 'End date',
        TARGET: 'End Target Value ',
        REF: 'Baseline Value',
        COMMENTS: 'Comments',
        ERROR: {
          DATE: 'The end date must be greater than the start date!',
          TARGET_VALUE: 'Please enter the End Target Value!',
          REF_VALUE: 'please enter the Baseline Value!',
          DATE_D: 'please enter the Start date!',
          DATE_F: 'please enter the End date!'
        }
      },
      MENU: {
        EDIT: 'Edit Indicator',
        PLAN: 'Plan Indicator',
        RELE: 'Collect Indicator data',
        FICHE: 'Indicator Sheet',
        IMAGE: 'Change Image',
        RIGHT: 'Indicator right',
        RAPPORT: 'Report',
        SPATIAL: 'Map',
        LEGEND: 'Legend'
      },
      RIGHT: {
        TITLE: 'Indicator right'
      },
      DASHBOARD: {
        TITLE2: '% completion by locality ',
        TITLE1_1: 'Indicator Tracking Table',
        TITLE1_2: 'Chart of Indicator progress per year ',
        LEGEND: '% completion',
        TITLE: 'INDICATOR DASHBORD',
        PAGE1TITLE: 'DASHBORD 1',
        PAGE2TITLE: 'DASHBORD 2',
        PAGE2SUBTITLE1: 'Indicator Progress by locality',
        PAGE2SUBTITLE2: 'Chart of Indicator Progress for locality '
      },
      SHEET: {
        SHEET: 'sheet',
        TITLE: 'Sheet of Indicator',
        NAME: 'Name of the Indicator',
        DESCRP: 'Description',
        TYPE: 'Type',
        RAT_CL: 'Attachment Logframe ',
        U_MES: 'Unit of measure',
        PER_COL_SUI: 'Frequency of collection and follow-up',
        NG: 'Geographic Level',
        RESPO: 'Responsible for collecting',
        TECH: 'Collection technique',
        SRC: 'Source of verification',
        FORMULA: 'Calculation Formula',
        VAL_REF: 'Reference value',
        VAL: 'Value',
        EVO: 'Indicator Progress'
      },
      SPATIALS: {
        DATA: 'Data\'s Layers',
        LAYERS: 'Layers',
        LABEL: 'Label',
        PERIODIC: 'Periodic',
        URL: 'URL',
        PROPERTY: 'Template',
        DATA_LAYER: 'Data Layer'
      }

    },
    LOGICAL_PLAN: {
      ADD: 'Add',
      HAS_INDIC: 'associate indicator',
      LABEL: 'label',
      LONG: 'length',
      ERROR_UPDATE_LONG: 'Can\'t update the length.',
      CONFIRM_DELETE_LEVEL: 'Do you want to delete this level?',
      CONFIRM_DELETE: 'Do you want to delete this data?',
      CODE: 'Code',
      DESCRP: 'Description',
      LABEL_C: 'Short Label',
      LABEL_L: 'Long label',
      IMPORT: 'Import...'
    },
    FLAG: {
      LABEL: 'Libellé',
      MIN: 'Min',
      MAX: 'Max',
      COLOR: 'Color',
      ERROR: {
        LABEL: 'Le libellé existe déjà.',
        CHEVAL: 'La période est à chevale sur une autre',
        IN: 'La période est incluse dans une autre',
        OUT: 'La période inclus une autre'
      }
    },
    FRAME_RESULT: {
      INDIC: 'Indicator',
      T_I: 'Filter '
    },
    ACTIVITY: {
      START: 'Starting Date',
      END: 'End Date',
      UNIT: 'Unit',
      UNIT_COST: 'unit cost',
      CAL_AUTO: 'Automatic calculation',
      BUDGET: 'Budget',
      COST_A: 'Actual Cost',
      RESPO: 'Responsible',
      COMMENT: 'Comments',
      IMPUT: 'Inputs',
      TOTAL: 'Total',
      CONT_LOC: 'Follow contract by locality',
      CONT_UNK: 'Only Contrat',
      NUM: 'Number',
      OWN: 'Owner',
      OBJECT: 'Object',
      COST: 'Cost',
      SIGN: 'Signature',
      BEGIN_CONTRACT: 'Begin',
      END_CONTRACT: 'End',
      BEGIN_D: 'Begin Date',
      END_D: 'End Date',
      PLAN: {
        TITLE: 'Activity Plan',
        REVIEW: 'Review',
        INIT: 'Initial',
        GLOBAL: 'Global',
        DURATION: 'Duration',
        TYPE: 'Type',
        AMOUNT: 'Amount',
        COST: 'Cost',
        LOCATION: 'Location',
        YEAR: 'Year',
        PERIOD: 'Period'
      },
      REAL: {
        TITLE: 'Actual'
      },
      DASHBOARD: {
        ALL_LOC: 'All Location',
        ANY_LOC: 'Any Location',
        BY_LOC: 'By Location',
        TITLE: 'Dashboard',
        RATE_PHY: 'Physical Rate',
        RATE_FINANC: 'Financial Rate',
        TITLE2: '% completion by locality ',
        TITLE1_1: 'Indicator Tracking Table',
        TITLE1_2: 'Chart of Indicator progress per year '
      },
      AWPB: {
        TITLE: 'Annual Workplan and Budget (AWPB)',
        TITLE_YEAR: 'Multi-annuel Workprogram and Budget'
      }
    },
    GANTT: {
      TITLE: 'Gantt Diagram',
      LIMIT: 'Chronogram Limits',
      TYPE: 'Planning Type',
      START: 'Start Date',
      END: 'End Date',
      DISPLAY: 'Display top levels bars',
      LEGEND: 'Legend',
      PLAN: 'Planned',
      ACTUAL: 'Actual',
      ACTOR: 'Actor',
      GEO: 'Géographic Plan',
      ZOOM: 'Zooming'
    },
    CONTRACT: {
      LOC: 'Location',
      N_MAR: 'N° Contract',
      PROGRESS: 'Progress',
      STEP: 'Step'
    },
    PROCUREMENT: {
      CONFIRM_DELETE: 'Do you want to delete this procurement?',
      CODE: 'Code',
      LABEL: 'label'
    },
    REPORT_CAT: {
      LABEL: 'Label',
      PERIOD: 'Periodicity',
      DELAI: 'Production Time',
      RECIPIENT: 'Recipient',
      FORMAT: 'Report Format',
      RESPO: 'Responsible',
      SELECT: 'Select file',
      CHANGE: 'Change',
      REMOVE: 'Remove',
      CONFIRM_DELETE: 'Do you want to delete this report categorie?',
      PERSON_ALERT: 'Stakeholders to alert'
    },
    DOCUMENT: {
      CLS: 'Filing Cabinets',
      ADD_FILE: 'Add Filing Cabinets',
      ADD_DOC: 'Add Document',
      CODE: 'Code',
      DESCRIP: 'Description',
      CONFIRM_DELETE_FOLDER: 'Do you want to delete this Filing Cabinets?',
      CONFIRM_DELETE_THEME: 'Do you want to delete this theme?',
      CONFIRM_DELETE_TYPE: 'Do you want to delete this type?',
      CONFIRM_DELETE_PHYS: 'Do you want to delete this Physique Location?',
      CONFIRM_DELETE_FILE: 'Do you want to delete this document?',
      RECIPIENT: 'Recipients',
      REFERENCE: 'Reference',
      PUBLICATION: 'Publication',
      PUBLIC: 'Publique',
      TITLE: 'Title',
      AUTHOR: 'Author',
      DOC_TYPE: 'Document Type',
      THEME: 'Theme',
      PHYS_LOC: 'Physique Location',
      SUMMARY: 'Summary',
      LABEL: 'Label',
      MAIN: 'Main',
      UPLOAD: 'Upload a file'
    },
    PHOTOLIBRARY: {
      REF: 'Reference',
      TITLE: 'Title',
      DATE: 'Date',
      PUBLIC: 'Public',
      LOCATION: 'Locality',
      LAT: 'Latitude (GPS)',
      LONG: 'Longitude (GPS)',
      AUTHOR: 'Author',
      SUMMARY: 'Summary',
      ADD_DOC: 'Add Photo',
      ADD_FILE: 'Add Folder',
      CONFIRM_DELETE_PHOTO: 'Do you want to delete this photo'
    },
    G_U: {
      EMAIL: 'Email',
      NAME: 'Name',
      SUP: 'Supervisor',
      PRENOM: 'First Name',
      MDP: 'Password',
      CONF: 'Confirmation',
      ACTOR: 'Stakeholder',
      ACTORLIST: 'Assign Stakeholders',
      CONFIRM_DELETE: 'Do you want to delete this user?',
      ERRORCONFPSW: 'not same passwords!',
      ERRORPSW: 'Password must contain at least 8 characters'

    },
    GR_U: {
      CODE: 'Code',
      LABEL: 'Label',
      CONFIRM_DELETE: 'Do you want to delete this group?',
      USER: 'Assign Users',
      LOCATION: 'Localities',
      LOCATION_ONLY: 'Locality only',
      LOCATION_ALL: 'Sub Localities'
    },
    RIGHT: {
      USER: 'Users',
      ADMIN: 'Administrator',
      PRIVIL: 'Privileges',
      LABEL: 'Label',
      CONFIRM_DELETE: 'Do you want to delete this profil?'
    }
  });
  cov_1unwywv3mq.s[2]++;
  $translateProvider.preferredLanguage('en');
});